<template>
  <div
    class="wv100"
    style="background-color: #f6f6f6;height: calc(100vh - 1.44rem)"
  >
    <baidu-map class="map" :center="center" :zoom="12" @ready="mapReady">
      <bm-marker
        v-for="(item, index) in markers"
        :key="index"
        @click="infoWindowOpen($event,item)"
        :position="{ lng: item.longitude, lat: item.latitude }"
      >
        <bm-info-window
          :key="mIndex"
          :show="item.show"
          @close="infoWindowClose(item)"
          @open="infoWindowOpen(item)"
          style="font-size:13px"
        >
        </bm-info-window>
      </bm-marker>
      <bm-geolocation
        anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
        :showAddressBar="true"
        :autoLocation="true"
      >
      </bm-geolocation>
    </baidu-map>
  </div>
</template>

<script>
import { getActivity } from "@/api/home";

import BaiduMap from "vue-baidu-map/components/map/Map.vue";

import BmView from "vue-baidu-map/components/map/MapView"; //地图视图

import BmMarker from "vue-baidu-map/components/overlays/Marker"; //点标注

import BmInfoWindow from "vue-baidu-map/components/overlays/InfoWindow"; //标注弹窗

import address from "@/assets/home_new/activity/address.png";

export default {
  components: {
    BaiduMap,

    BmView,

    BmMarker,

    BmInfoWindow
  },

  data() {
    return {
      mIndex: 0,
      markerPoint: { lng: 111.674919, lat: 40.820154 },
      show: false,
      markers: [],
      myGeo: "",
      center: { lng: 111.674919, lat: 40.820154 }
    };
  },
  props: {
    selectAddress: {
      type: Function,
      defaults: ""
    }
  },
  mounted() {
    // this.mapReady();
    // this.getLocationPoint();
    const _this = this;

    // var map = new BMapGL.Map("container");          // 创建地图实例
    // var point = new BMapGL.Point(111.698617, 40.847829);  // 创建点坐标
    // map.centerAndZoom(point, 15);                 // 初始化地图，设置中心点坐标和地图级别
    //
    // var geolocation = new BMapGL.Geolocation();
    // geolocation.getCurrentPosition(function (r) {
    //   var mk = new BMapGL.Marker(r.point);
    //   map.addOverlay(mk);
    //   map.panTo(r.point);
    //   _this.point = {
    //     lng: r.point.lng,
    //     lat: r.point.lat
    //   };
    // });


  },
  methods: {
    mapReady({ BMap, map }) {
      this.initAddress();
      const _this = this;
      // 获取自动定位方法
      var geolocation = new BMap.Geolocation();
      // 获取逆解析方法实例
      this.myGeo = new BMap.Geocoder();
      // 获取自动定位获取的坐标信息
      geolocation.getCurrentPosition(function (r) {
        let myGeo = new BMap.Geocoder()
        myGeo.getLocation(new BMap.Point(r.point.lng, r.point.lat), function (r) {
          if (r) {
            _this.center = {
              lng: r.point.lng,
              lat: r.point.lat
            };
          }
        });
      });
      // geolocation.getCurrentPosition(
      //   function(r) {
      //     console.info(r);
      //     _this.center = {
      //       lng: r.point.lng,
      //       lat: r.point.lat
      //     };
      //     _this.point = {
      //       lng: r.point.lng,
      //       lat: r.point.lat
      //     };
      //   },
      //   { enableHighAccuracy: true }
      // );
    },
    initAddress(item) {
      var _this = this;
      getActivity({})
        .then(res => {
          console.info(res);
          _this.markers = [];
          for (const key of Object.keys(res)) {
            for (const reElement of res[key]) {
              _this.markers.push(reElement);
            }
          }
          console.info(_this.markers);

          // _this.markers = res;
        })
        .catch(e => {
          console.info(e);
          _this.$message.error("网络请求异常!" + e);
        });
    },
    infoWindowClose(item) {
      item.show = false;
    },
    infoWindowOpen($event,item) {
      this.$router.push({ path: "/second_level?id=" + item.activityId });

      // this.$tip({
      //   title: "提示",
      //   show: true,
      //   type: "",
      //   message: "<i style='font-size: 0.4rem;font-weight: 600'>"+item.activityTitle+"</i> <br/> <i style='font-size: 0.3rem'>"+item.descText+"</i>",
      //   confirmBtnText: "查看详情",
      //   onConfirm: function (e) {
      //     this.$router.push({ path: "/second_level?id=" + item.activityId });
      //   }
      // });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/flex.css";

.map {
  width: 100%;
  height: 100%;
}
</style>
